var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76474 4.03408C3.76474 2.67844 4.86764 1.57553 6.22328 1.57553C7.57893 1.57553 8.68183 2.67844 8.68183 4.03408C8.68183 5.38972 7.57893 6.49263 6.22328 6.49263C4.86764 6.49263 3.76474 5.38972 3.76474 4.03408ZM8.24765 7.01927C7.97279 6.94945 7.67384 6.98879 7.42651 7.12647C6.68009 7.54147 5.76647 7.54147 5.02006 7.12647C4.77322 6.98928 4.47378 6.95043 4.19891 7.01927C3.21943 7.2666 2.53546 8.15561 2.53546 9.18082V9.67793C2.53546 9.99165 2.61904 10.2984 2.77786 10.5659C2.90718 10.7833 3.14961 10.9185 3.40973 10.9185H9.03636C9.29647 10.9185 9.53887 10.7838 9.66819 10.5654C9.82701 10.2984 9.91062 9.99165 9.91062 9.67793V9.18082C9.91112 8.15561 9.22714 7.2666 8.24765 7.01927Z",
    fill: "#234240"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.a20113bb067509f47570fcd944e3968b.svg";
export { ForwardRef as ReactComponent };